import { publicRequest } from "../../../requestMeth";
import {
  alertEventsStart,
  alertEventsSuccess,
  notificationsCountSuccess,
  alertEventsFailure,
} from "../../reducers/alertEventsRedux";

export const getAllAlertEvents = async (dispatch, token, filters = {}) => {
  dispatch(alertEventsStart());

  try {
    const {
      page = 1,
      limit = 20,
      type,
      dateFrom,
      dateTo,
      device_name,
      device_ids,
    } = filters;

    const res = await publicRequest.get("/alert-events", {
      headers: { token: `Bearer ${token}` },
      params: {
        page,
        limit,
        ...(type && { type }),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
        ...(device_name && { device_name }),
        ...(Array.isArray(device_ids) && device_ids.length > 0
          ? { device_ids }
          : {}),
      },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const getAlertEventsByDeviceId = async (dispatch, device_id, token) => {
  dispatch(alertEventsStart());

  try {
    const res = await publicRequest.get(`/alert-events/device/${device_id}`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const getAlertEventById = async (dispatch, id, token) => {
  dispatch(alertEventsStart());

  try {
    const res = await publicRequest.get(`/alert-events/${id}`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const getAlertEventByDevice = async (dispatch, id, token) => {
  dispatch(alertEventsStart());

  try {
    const res = await publicRequest.get(`/alert-events/device/${id}`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const updateAlertEvent = async (dispatch, id, event, token) => {
  dispatch(alertEventsStart());

  try {
    const res = await publicRequest.put(`/alert-events/${id}`, event, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const deleteAlertEvent = async (dispatch, id, token) => {
  dispatch(alertEventsStart());

  try {
    const res = await publicRequest.delete(`/alert-events/${id}`, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const getNotificationsCount = async (dispatch, token, opts = {}) => {
  dispatch(alertEventsStart());

  try {
    const { device_ids, dateFrom, dateTo } = opts;

    const res = await publicRequest.get("/alert-events/notifications-count", {
      headers: { token: `Bearer ${token}` },
      params: {
        ...(Array.isArray(device_ids) && device_ids.length > 0
          ? { device_ids }
          : {}),
        ...(dateFrom && { dateFrom }),
        ...(dateTo && { dateTo }),
      },
    });

    dispatch(notificationsCountSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};

export const updateAlertEventsBulk = async (dispatch, payload, token) => {
  dispatch(alertEventsStart());

  try {
    const res = await publicRequest.put(`/alert-events/bulk`, payload, {
      headers: { token: `Bearer ${token}` },
    });

    dispatch(alertEventsSuccess(res.data));
    return res.data;
  } catch (error) {
    dispatch(alertEventsFailure());
    throw error;
  }
};
